import dayjs from 'dayjs';
import { formatDate, formatDateTime } from '../../../../../../common/formatters';

/**
 * Converts backend time format (07:00:00) to user-friendly frontend format (7:00 AM).
 * @param time - Time string in HH:mm:ss format or null
 * @returns Formatted time string in h:mm A format or empty string if null
 */
export const formatTimeForDisplay = (time: string | null): string => {
  if (!time) return '';
  return dayjs(`2000-01-01T${time}`).format('h:mm A');
};

/**
 * Converts frontend time format (7:00 AM) to backend format (07:00:00).
 * @param time - Time string in h:mm A format
 * @returns Time string in HH:mm:ss format or null if empty
 */
export const formatTimeForBackend = (time: string): string | null => {
  if (!time) return null;
  return dayjs(`2000-01-01 ${time}`).format('HH:mm:ss');
};

/**
 * Formats complete follow-up date and time for display in cards.
 * @param date - Date string from backend
 * @param time - Time string in HH:mm:ss format or null
 * @returns Formatted string like "08-Aug-2025 7:00 AM" or just date if no time
 */
export const formatFollowUpDateTime = (date: string, time: string | null): string => {
  const formattedDate = formatDate(date);
  if (time) {
    const formattedTime = formatTimeForDisplay(time);
    return `${formattedDate} ${formattedTime}`;
  }
  return formattedDate;
};

/**
 * Formats metadata timestamps using standard application format.
 * @param timestamp - ISO timestamp string
 * @returns Formatted timestamp in DD-MMM-YYYY h:mm A format
 */
export const formatMetadataTimestamp = (timestamp: string): string => {
  return formatDateTime(timestamp);
};
